<template>
  <div style="display: inline-block">
    <div class="model-wrapper">
      <!-- <div id="three"></div> -->
    </div>
    <div class="hero-text">
      <div class="text-wrapper">
        <div class="line line-up"></div>
        <h3 class="letters letters-left" style="font-size: 112px; margin-top: 24px; font-family: Ownglyph_meetme-Rg">
          VIRTU
        </h3>
        <div class="letters logo ml-2">
          <!-- <virtupet-icon :size="80"></virtupet-icon> -->
          <div id="three"></div>
        </div>
        <h3 class="letters letters-right" style="font-size: 112px; font-family: Ownglyph_meetme-Rg">PET</h3>
        <div class="line line-bottom"></div>
      </div>
    </div>
    <div class="d-flex justify-end copy-light">© 2024 virtupet co. All rights reserved.</div>
  </div>
</template>

<script>
import { createTimeline } from "animejs";

import AppRenderer from "@/domain/AppRenderer";
import AppModelFacade from "@/domain/facades/AppModelFacade";

const defaultCameraPosition = {
  x: 0.34462566143723866,
  y: 0.8573113065464888,
  z: 1.718044448155407,
  _x: -0.08861077948998768,
  _y: 0.5241708098872303,
  _z: -0.2821844891225064,
};

export default {
  components: {},
  async mounted() {
    const appModel = await AppModelFacade.fetchRandomModel();

    // set size
    const parent = this.$el.querySelector("#three");
    const size = 120;
    const appRenderer = AppRenderer.create(appModel, { width: size, height: size }, defaultCameraPosition, 0.0005);
    parent.appendChild(appRenderer.canvasEl);

    setTimeout(() => {
      appRenderer.appAnimationController.play("hi");
    }, 3300);

    setTimeout(() => {
      appRenderer.appAnimationController.stop();
    }, 3300 + 2000);

    createTimeline({}).add(".hero-text .logo", {
            opacity: [0, 1],
      scaleY: [0, 1],
      translateX: ["-24px", "-24px"],
      // translateY: ["10px", "10px"],
      ease: "linear",
      duration: 700,
      delay: 600,
      // offset: "-=600",
    });

    createTimeline({})
      .add(".hero-text .line", {
                opacity: [0.5, 1],
        scaleX: [0, 1],
        ease: "inOutExpo",
        duration: 600,
      })
      .add(".hero-text .line", {
                duration: 600,
        opacity: [1, 0.7],
        ease: "inSine",
        translateY: (el, i) => -0.625 + 0.625 * 2 * i + "em",
      })
      .add(".hero-text .letters-left", {
                opacity: [0, 1],
        translateX: ["0.5em", 0],
        translateY: ["-8px", "-8px"],
        ease: "outExpo",
        duration: 800,
      })
      .add(".hero-text .letters-right", {
                opacity: [0, 1],
        translateX: ["-0.5em", 0],
        translateY: ["-8px", "-8px"],
        ease: "outExpo",
        duration: 800,
      })
      // .add({
      //   targets: ".model-wrapper",
      //   opacity: [0, 1],
      //   ease: "outExpo",
      //   duration: 200,
      // })
      .add(".copy-light", {
                opacity: [0, 1],
        translateY: ["-1.5em", "-1.5em"],
        ease: "outExpo",
        duration: 600,
      });
  },
};
</script>

<style lang="scss" scoped>
.hero-text {
  position: relative;
  font-weight: 300;
  letter-spacing: 0.4rem;
  font-size: 6em; // change font- size
}

.hero-text .text-wrapper {
  position: relative;
  display: inline-block;
  padding-top: 0.1em;
  padding-right: 0.05em;
  padding-bottom: 0.15em;
  line-height: 1em;
}

.hero-text .line {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 4px;
  width: 100%;
  transform-origin: 0.5 0;
  // background-color: #9155fd;
  background: linear-gradient(to right, #ae00ff, #9155fd);
}

.hero-text .logo {
  font-family: Baskerville, serif;
  font-style: italic;
  font-weight: 400;
  width: 1em;
  margin-right: -0.1em;
  margin-left: -0.1em;
}

.hero-text .letters {
  display: inline-block;
  opacity: 0;
}

.hero-text .letters-left {
  color: #380245;
  transform: translateY(200%);
}

.hero-text .letters-right {
  color: #8b4dff;
}

.hero-text .copy-light {
  font-size: 12px;
}

.model-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(80%);
}
</style>
